import {makeAutoObservable, observable, reaction} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable} from "inversify";
import {IMarketsOdds} from "data/types/entities";
import {ChangeOddsType} from "data/enums";

interface IParams {
	odds: IMarketsOdds;
}

export interface IOddsController extends ViewController<IParams> {
	get changeState(): ChangeOddsType;
}

@injectable()
export class OddsController implements IOddsController {
	@observable _changeState: ChangeOddsType = ChangeOddsType.None;
	@observable _clearDisposer: ReturnType<typeof reaction> | null = null;
	private _odds?: IMarketsOdds;

	constructor() {
		makeAutoObservable(this);
	}

	get changeState() {
		return this._changeState;
	}

	init(param: IParams) {
		this._odds = param.odds;

		reaction(
			() => this.changeState,
			() => (this._changeState = ChangeOddsType.None),
			{
				delay: 5000,
			}
		);
	}

	onChange(param: IParams) {
		if (this.changeState !== param.odds.history) {
			this._changeState = param.odds.history;
			return;
		}

		if (this._odds) {
			if (this._odds.value < param.odds.value) {
				this._changeState = ChangeOddsType.UP;
				return;
			}

			if (this._odds.value > param.odds.value) {
				this._changeState = ChangeOddsType.DOWN;
				return;
			}

			this._changeState = ChangeOddsType.None;
		}
	}

	dispose() {
		this._clearDisposer?.();
	}
}
